(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-preview"] && !Shopify.designMode) return;
  try {
    class variantFrameSelector extends HTMLElement {
    #preVariantId

    /** @param {string} sku */
    #applySkuToPreview(sku) {
      const match = /^NUFS(\d{6})([A-Z]{2})(?:([A-Z]{2}))?(\d{2,3}[A-Z]\d{2,3})$/.exec(sku)
      if (!match) return

      const [, , productType, productVariant] = match

      const preview = this.querySelector('.hdt-preview')
      if (!preview) return
      preview.setAttribute('data-frame-type', productType ?? 'undefined')
      preview.setAttribute('data-frame-variant', productVariant ?? 'undefined')
    }

    // frame:preview-update fires directly from the frame picker — instant, no fetch
    #handleFramePreviewUpdate = (event) => {
      const { frameType, frameVariant } = event.detail || {}
      if (!frameType) return

      const preview = this.querySelector('.hdt-preview')
      if (!preview) return
      preview.setAttribute('data-frame-type', frameType)
      preview.setAttribute('data-frame-variant', frameVariant || 'undefined')
    }

    // variant:selected fires instantly when user picks an option — no fetch wait
    #handleVariantSelected = (event) => {
      const optionValueId = event.detail?.resource?.id
      if (!optionValueId) return

      // Read the variant ID from the selected input element
      const input = document.querySelector(`[data-option-value-id="${optionValueId}"]`)
      const variantId = input?.dataset.variantId
      if (!variantId) return
      if (this.#preVariantId === variantId) return

      const skuMap = this.#getSkuMap()
      if (!skuMap) return

      const sku = skuMap[variantId]
      if (!sku) return

      this.#preVariantId = variantId
      this.#applySkuToPreview(sku)
    }

    // variant:update fires after fetch — used as fallback / confirmation
    #handleVariantUpdate = (event) => {
      const variant = event.detail?.resource
      if (!variant?.sku) return
      if (this.#preVariantId === String(variant.id)) return

      this.#preVariantId = String(variant.id)
      this.#applySkuToPreview(variant.sku)
    }

    #getSkuMap() {
      const script = this.querySelector('script[data-variant-sku-map]')
      if (!script) return null
      try {
        return JSON.parse(script.textContent)
      } catch {
        return null
      }
    }

    connectedCallback() {
      document.addEventListener('frame:preview-update', this.#handleFramePreviewUpdate)
      document.addEventListener('variant:selected', this.#handleVariantSelected)
      document.addEventListener('variant:update', this.#handleVariantUpdate)
    }

    disconnectedCallback() {
      document.removeEventListener('frame:preview-update', this.#handleFramePreviewUpdate)
      document.removeEventListener('variant:selected', this.#handleVariantSelected)
      document.removeEventListener('variant:update', this.#handleVariantUpdate)
    }
  }

  customElements.define('variant-frame-selector', variantFrameSelector)
  } catch(e) { console.error(e); }
})();

})();
